module.exports = __webpack_public_path__ + "img/icon_003.7ae9b24.png";